import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './assets/sass/general.scss';
import SnirhApp from './SnirhApp';

ReactDOM.render(<SnirhApp />, document.getElementById('portal-do-snirh'));